enum ResizeHandleScenario {
    ReadingPane = 1,
    FolderPane,
    MailListColumnHeader1, // Handle between first and second columns
    MailListColumnHeader2, // Handle between second and third columns
    CopilotChatDrawer, // Handle for the right-side Copilot Chat Drawer
    MailListColumnHeaderSortedContent, // Handle for the sorted content column between sorted column and last column
    AddinsPane, // Handle for the Addins pane in the new header experience
    PersonalOSChatPanel, // Handle for the PersonalOS chat panel
    PersonalOSDetailPane,
}

export default ResizeHandleScenario;
